import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react';
import { useDashboardFollowUps } from '../../hooks/useDashboardFollowUps';
import { useUserSettings } from '../../hooks/useUserSettings';
import LoadingPage from '../../components/ui/LoadingPage';
import ContactGrid from '../../components/ContactGrid';

export default function FollowUps() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCompany, setSelectedCompany] = useState('All Companies');
  const { followUps, loading } = useDashboardFollowUps(365, true);
  const { settings, loading: settingsLoading } = useUserSettings();
  const shouldAnonymize = settings?.anonymizing_mode || false;

  if (loading || settingsLoading) {
    return <LoadingPage message="Loading follow-ups..." />;
  }

  const filteredFollowUps = followUps.filter(followUp => {
    const matchesSearch = searchTerm === '' || 
      followUp.contact.first_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      followUp.contact.last_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      followUp.contact.work_email?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesCompany = selectedCompany === 'All Companies' ||
      followUp.contact.company?.name === selectedCompany;

    return matchesSearch && matchesCompany;
  });

  const companies = [...new Set(followUps.map(f => f.contact.company?.name).filter(Boolean))];

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-white">Follow Ups Focus</h1>

      <div className="space-y-4">
        {/* Search and Filter Row */}
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex-1">
            <label className="block text-sm text-gray-400 mb-1">Search</label>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search contacts..."
                className="w-full pl-10 pr-4 py-2 bg-dark-800 border border-dark-700 rounded-md text-gray-100 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          <div className="md:w-72">
            <label className="block text-sm text-gray-400 mb-1">Filter By Company</label>
            <select
              className="w-full px-4 py-2 bg-dark-800 border border-dark-700 rounded-md text-gray-100 focus:outline-none focus:ring-1 focus:ring-primary-500"
              value={selectedCompany}
              onChange={(e) => setSelectedCompany(e.target.value)}
            >
              <option>All Companies</option>
              {companies.map(company => (
                <option key={company}>{company}</option>
              ))}
            </select>
          </div>
        </div>

        <ContactGrid 
          contacts={filteredFollowUps}
          shouldAnonymize={shouldAnonymize}
        />
      </div>
    </div>
  );
} 